import React from "react";
// import SettingsIcon from "@material-ui/icons/Settings";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import onClickOutside from "react-onclickoutside";
import PersonIcon from "@material-ui/icons/Person";
import DescriptionIcon from "@material-ui/icons/Description";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import API_ENDPOINT from "../wm.api.service";
import { encode, decode } from "base-64";
import Cookies from "universal-cookie";
import { LogoutIcon, UserCircleIcon } from "@heroicons/react/outline";

const cookies = new Cookies();
function ProfilePopup({ className, close, logout, rootData, resume }) {
  if (cookies.get("wmusers")) {
    var user = decode(cookies.get("wmusers"));
  } else {
    var user = "members";
  }
  ProfilePopup.handleClickOutside = () => close();
  return (
    <React.Fragment>
      <div
        className={`absolute w-52 bg-white right-0 rounded-md shadow px-2 py-2 transform translate-y-2 ${className}`}
      >
        <div className="arrowCret"></div>
        <a
          href={`${API_ENDPOINT.redirectURL}/${rootData.username}`}
          className=" text-gray-700 underline-none"
          onClick={() => close()}
        >
          <div className=" text-gray-700 py-2 pl-2 accountBG flex items-center text-sm">
            <UserCircleIcon className="w-6 mr-2" />
            <span className=" text-gray-700">Profile</span>
          </div>
        </a>
        {/* {user === 'members' && <>{rootData.isResumeCreated || resume.isResumeCreated ? <Link to={`/editresume/${encode('about-me')}`} className=" text-gray-700 underline-none">
                    <div className=" text-gray-700 py-2 pl-2 accountBG">
                        <DescriptionIcon className="mr-2" />
                        <span className=" text-gray-700">Edit Resume</span>
                    </div>
                </Link> : <Link to={`/createresume/${encode('about-me')}`} className=" text-gray-700 underline-none">
                    <div className=" text-gray-700 py-2 pl-2 accountBG">
                        <DescriptionIcon className="mr-2" />
                        <span className=" text-gray-700">Create Resume</span>
                    </div>
                </Link>}</>} */}
        {/* {user === 'members' && <> <Link to={`/resume/content`} className=" text-gray-700 underline-none">
                    <div className=" text-gray-700 py-2 pl-2 accountBG">
                        <DescriptionIcon className="mr-2" />
                        <span className=" text-gray-700">Create Resume</span>
                    </div>
                </Link></>} */}
        <div
          className=" text-gray-700 py-2 pl-2 accountBG flex items-center text-sm"
          onClick={() => logout()}
        >
          <LogoutIcon className="w-6 mr-2" />
          <span className=" text-gray-700">Sign out</span>
        </div>
      </div>
    </React.Fragment>
  );
}
const clickOutsideConfig = {
  handleClickOutside: () => ProfilePopup.handleClickOutside,
};

const mapStateToProps = (state) => {
  return state;
};
export default connect(
  mapStateToProps,
  null
)(onClickOutside(ProfilePopup, clickOutsideConfig));
